<template>
    <div class="produkt-zufallsgenerator container-fluid mb-7 mb-sm-8 mb-lg-9" :class="{aktiv: istProduktAnsicht}">
        <div class="row" style="position: relative">
            <div class="produkt-zufallsgenerator-hintergrund col-12 col-reset d-flex align-items-center mb-0" :style="setzenHintergrundStyles" ref="produktWrapper">
                <div class="container" v-if="!zeigeProdukte">
                    <div class="row d-flex flex-row-wrap h-100" >
                        <div class="col-12 d-flex justify-content-center flex-column align-items-center">
                            <h2 class="start-headline fs-4 fs-md-8 text-center text-white mb-4" :class="{ausblenden: istProduktAnsicht}" @transitionend="produktAnsicht">
                                {{ this.optionen.i18n.startHeadline }}
                            </h2>
                            <div :style="setzenPlatzhalterStyles">
                                <refresh-button
                                    v-if="!istProduktAnsicht"
                                    class="refresh-btn"
                                    :clickHandler="ansichtWechseln"
                                    :isBtnClicked="false"
                                />
                            </div>
                            <p class="refresh-text text-white text-center fs-3 mt-3" :class="{ausblenden: istProduktAnsicht}" v-html="this.optionen.i18n.startButtontext"></p>
                            <p v-if="requestFehlermeldung != ''" class="fehler">{{ this.optionen.i18n.requestFehlermeldung }}</p>
                        </div>
                    </div>
                </div>
                <div class="container" v-if="zeigeProdukte">
                    <div class="row flex-row-wrap h-100">
                        <intro-mobil v-if="istMobile && !introMobilGezeigt" @intro-mobil-ende="introMobilGezeigt = true" />
                        <div class="col-12 mb-0 d-flex justify-content-center align-items-center">
                            <produkt-stapel ref="produktStapel"
                              :produktDaten="produktDaten"
                              :srcBildPlatzhalter="srcBildPlatzhalter"
                              :optionen="optionen"
                              @aktualisiere-daten="holeProduktDaten"
                              @aktualisiere-index="aktualisierenIndex"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <zurueck-button
                    v-if="istProduktAnsicht && !istMobile"
                    class="zurueck-btn"
                    :clickHandler="vorherigesProdukt"
                    :class="{anzeigen: btnZurueckAnzeigen}"

                />
                <refresh-button
                    v-if="istProduktAnsicht"
                    class="refresh-btn"
                    :class="{next: istProduktAnsicht}"
                    @refresh-icon-end="naechstesProdukt"
                    @refresh-btn-bottom="refreshBtnBottomHandler"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Helpers from './Helpers';
import ProduktStapel from './components/ProduktStapel.vue';
import RefreshButton from './components/RefreshButton.vue';
import ZurueckButton from './components/ZurueckButton.vue';
import IntroMobil from './components/IntroMobil.vue';

export default {
    name: 'produktZufallsgenerator',
    components: {
        ProduktStapel,
        RefreshButton,
        ZurueckButton,
        IntroMobil
    },
    props: {
        optionen: Object,
    },
    data() {
        return {
          produktDaten: [],
          srcBildPlatzhalter: '',
          zeigeProdukte: false,
          istProduktAnsicht: false,
          requestVersuche: 0,
          requestMaxVersuche: 3,
          requestVersuchTimeout: 1500,
          requestFehlermeldung: '',
          istMobile: false,
          introMobilGezeigt: false,
          btnZurueckAnzeigen: false,
          aktuellerProduktIndex: 0,
        }
    },
    computed: {
        setzenHintergrundStyles() {
            return {
                minHeight: this.istMobile ? '500px' : '530px',
                overflow: 'hidden',
                backgroundImage: `url(${this.istProduktAnsicht ? this.optionen.hintergrund.aktiv : this.optionen.hintergrund.inaktiv})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: '5%',
            }
        },

        setzenPlatzhalterStyles() {
            return {
                position: !this.istProduktAnsicht ? 'relative' : 'static',
                width: '100%',
                height: '160px',
                margin: '10px 0',
            }
        },
    },
    methods: {
        holeProduktDaten() {
            this.$http.get(this.optionen.request.url, {params: this.optionen.request.parameter}).then( response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    this.wiederholenProduktRequest();
                }
            }).then(response => {
                this.produktDaten = response.produkte ? [...this.produktDaten, ...response.produkte] : this.produktDaten;
                this.srcBildPlatzhalter = response.bildPlatzhalter ? response.bildPlatzhalter : '';
                this.requestVersuche = 0;
                this.requestFehlermeldung = '';
            }, response => {
                if (response.status && response.statusText) {
                    console.error(`Es ist ein Fehler aufgetreten: ${response.status} - ${response.statusText}`);
                    this.wiederholenProduktRequest();
                } else {
                    console.error(`Es ist ein Fehler aufgetreten: ${response}`);
                }
            });
        },
        wiederholenProduktRequest() {
            if (this.requestVersuche < this.requestMaxVersuche) {
                this.requestVersuche++;
                setTimeout(() => {
                    this.holeProduktDaten();
                }, this.requestVersuchTimeout);
            } else {
                this.requestFehlermeldung = this.optionen.i18n.requestFehlermeldung;
            }
        },
        naechstesProdukt() {
            this.$refs.produktStapel.naechstesProdukt();
        },
        vorherigesProdukt() {
            this.$refs.produktStapel.vorherigesProdukt();
        },
        ansichtWechseln() {
            this.istProduktAnsicht = true;
        },
        produktAnsicht() {
            if (this.produktDaten.length > 0) {
                this.zeigeProdukte = true;
            }

            if (this.produktDaten.length == 0 && this.requestVersuche >= this.requestMaxVersuche) {
                this.requestVersuche = 0;
                this.requestFehlermeldung = '';
                this.holeProduktDaten();
            }
        },
        refreshBtnBottomHandler() {
            if (this.aktuellerProduktIndex > 0) {
                this.btnZurueckAnzeigen = true;
            }
        },
        aktualisierenIndex(index) {
            this.aktuellerProduktIndex = index;
            if (this.aktuellerProduktIndex > 0) {
                this.btnZurueckAnzeigen = true;
            } else {
                this.btnZurueckAnzeigen = false;
            }
        }
    },
    created() {
        this.holeProduktDaten();
        this.istMobile = Helpers.pruefenDarstellungIstMobil(this.optionen.responsive.breakpointDesktop);

        window.addEventListener('resize', () => {
            this.istMobile = Helpers.pruefenDarstellungIstMobil(this.optionen.responsive.breakpointDesktop);
        });

    },
    mounted() {
        this.maxHeight = this.$refs.produktWrapper.clientHeight;
    },

}


</script>

<style lang="scss" scoped>

    .produkt-zufallsgenerator {

        &.aktiv {
            margin-bottom: 110px !important;
        }

        .start-headline,
        .refresh-text {
            opacity: 1;
            transition: opacity 1000ms ease-in-out;

            &.ausblenden {
                opacity: 0;
            }
        }

        .refresh-text {
            width: 40%;
            text-align: center;
        }

    }

    .produkt-zufallsgenerator-hintergrund {
        transition: background 300ms ease-in-out;
    }

    @media (max-width: 991px) {
      .produkt-zufallsgenerator-hintergrund {
            background-position: center;
            background-size: cover;
      }

    .produkt-zufallsgenerator {
       .refresh-text {
            width: 80%;
            text-align: center;
            }
        }
    }


</style>